module.exports = __webpack_public_path__ + "img/lowhighalarm_pumpstation.7b5fc04a.svg";